import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import * as Colors from 'material-ui/styles/colors';

import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from '../Common/TextField';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    checkbox: {
        margin: '16px',
    },
    checkboxColumn: {
        width: '3em',
        textAlign: 'center'
    },
    requirementColumn: {
        width: '3em',
        textAlign: 'center'
    },
    textFieldNumber: {
        textAlign: "right",
    }
};

class CourseModuleTable extends Component {

    render() {
        const tableProps = {
            selectable: this.props.selectable
        };
        const headerProps = {
            enableSelectAll:    this.props.selectable,
            displaySelectAll:   this.props.selectable,
            adjustForCheckbox:  this.props.selectable
        };
        const bodyProps = {
            deselectOnClickaway: false,
            showRowHover:        false,
            stripedRows:         false,
            displayRowCheckbox:  this.props.selectable
        };

        const topRight = {horizontal: 'right', vertical: 'top'};
        const iconMenuProps = {
            menuStyle:      style.menu,
            anchorOrigin:   topRight,
            targetOrigin:   topRight,
        };
        iconMenuProps.iconButtonElement = <IconButton touch={true} >
            <MoreVertIcon color={Colors.grey400} style={style.iconButton} />
        </IconButton> ;

        let reqValidations = {
            isNumeric: true,
            range: function(values, value) { return 0 <= value && value <= 100; }
        };
        return <Table {...tableProps}>
            <TableHeader {...headerProps}>
                <TableRow>
                    <TableHeaderColumn>Module</TableHeaderColumn>
                    <TableHeaderColumn className="column-mandatory" style={style.checkboxColumn}>Required</TableHeaderColumn>
                    <TableHeaderColumn className="column-requirement" style={style.requirementColumn}>Pass mark</TableHeaderColumn>
                    <TableHeaderColumn/>
                </TableRow>
            </TableHeader>
            <TableBody {...bodyProps} >
                {this.props.data.map(function(module) {
                    let summary = (module.name + ' - ' + module.code);
                    let infoLink = this.props.infoLink.replace('{id}', module.id);
                    let actions = [];

                    if (this.props.actions)
                        actions = this.props.actions(module);

                    let reqName = 'module[' + module.id + '][requirement]';
                    let manName = 'module[' + module.id + '][mandatory]';
                    return <TableRow key={module.id} selected={false}>
                        <TableRowColumn>
                            <Link to={infoLink} className="primaryText">{summary}</Link>
                        </TableRowColumn>
                        <TableRowColumn className="column-mandatory" style={style.checkboxColumn} >
                            <Checkbox
                                name={manName}
                                defaultChecked={module.mandatory}
                                onChange={(e, value) => this.props.onModuleChange({
                                    moduleId: module.id,
                                    mandatory: value
                                })}
                            />
                        </TableRowColumn>
                        <TableRowColumn className="column-requirement" style={style.requirementColumn} >
                            <TextField
                                inputStyle={style.textFieldNumber}
                                name={reqName}
                                value={module.requirement}
                                validations={reqValidations}
                                validationError="Please enter a number between 0 and 100"
                                onChange={({target}) => this.props.onModuleChange({
                                    moduleId: module.id,
                                    requirement: target.value
                                })}
                            />
                        </TableRowColumn>
                        <TableRowColumn>{actions}</TableRowColumn>
                    </TableRow>;
                }, this)}
            </TableBody>
        </Table>;
    }
}

CourseModuleTable.contextTypes = {
    auth: PropTypes.object.isRequired
};

CourseModuleTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.func.isRequired,
    onModuleChange: PropTypes.func.isRequired,
    selectable: PropTypes.bool,
    infoLink: PropTypes.string
};

CourseModuleTable.defaultProps = {
    infoLink: '/dashboard/module/{id}',
    selectable: false
};


export default CourseModuleTable;
